<div class="error">
  <h1>404 </h1>
  <h2>Page not found <i class="material-icons">sentiment_very_dissatisfied</i></h2>
</div>
